import { render, staticRenderFns } from "./creativeGroup.vue?vue&type=template&id=2f6161a6&scoped=true&"
import script from "./creativeGroup.vue?vue&type=script&lang=js&"
export * from "./creativeGroup.vue?vue&type=script&lang=js&"
import style0 from "./creativeGroup.vue?vue&type=style&index=0&id=2f6161a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6161a6",
  null
  
)

export default component.exports